import { Component, Input, OnInit } from '@angular/core';
import { SideBar, SideBarService } from '../../services/side-bar.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent {
  @Input() isMobile = false;

  // Tracks whether the mobile stepper is opened or closed.
  isMobileStepperSideBarOpened = false;

  constructor(private sideBarService: SideBarService) {}

  handleOnClickCollapseNav() {
    this.isMobileStepperSideBarOpened = !this.isMobileStepperSideBarOpened;
  }

  handleOnClickOutsideCollapseNav() {
    this.isMobileStepperSideBarOpened = false;
  }

  // region getters
  get sidebar(): typeof SideBar {
    return SideBar;
  }

  get sidebarState(): SideBar {
    return this.sideBarService.sideBarState;
  }

  // region Applicable only if sideBarState === SideBar.Default
  get title() {
    return this.sideBarService.title;
  }
  // endregion

  // region Applicable only if sideBarState === SideBar.Stepper
  get stepperRoute() {
    return this.sideBarService.filteredStepperRoutes;
  }

  get currentStep() {
    return this.sideBarService.currentStep;
  }

  get totalStep() {
    return this.stepperRoute.length;
  }
  // endregion

  //endregion
}
